// 课程与小组
import { sendLogById, sendLogClick } from './index'

export default {
  // 页面初始化
  initPageLogger(data) {
    sendLogById('smallfox-teacher_29', {
      ...data
    })
  },
  // 创建小组
  addGroupLogger(data) {
    sendLogClick('smallfox-teacher_4', {
      ...data
    })
  }
}